var render = function render(){var _vm=this,_c=_vm._self._c;return _c('perfect-scrollbar',[_c('v-select',{attrs:{"multiple":_vm.multipleSelect,"chips":"","items":_vm.headers,"hint":"Choose the required headers","persistent-hint":""},model:{value:(_vm.localSelectedHeaders),callback:function ($$v) {_vm.localSelectedHeaders=$$v},expression:"localSelectedHeaders"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }